import { cn } from "@dalmatech/ui"

export const triggerButton = cn(
  "flex h-10 w-10 items-center justify-center rounded-full bg-neutral-100 hover:bg-neutral-200 transition-colors"
)

// Invisible rail anchored to the navbar's fixed container: top-full puts the
// card below the whole block (banners + row + mobile progress bar), 16px off
// the viewport edges as in the Figma frames.
export const cardPositioner = cn(
  "pointer-events-none absolute inset-x-0 top-full z-10 flex justify-end px-4"
)

export const card = (isClosing: boolean) =>
  cn(
    "mt-4 flex w-full flex-col gap-6 rounded-2xl border border-white/[.32] bg-blurple-500 p-5 md:w-[361px]",
    // contain:paint keeps the per-frame repaints of the morph scoped to the card
    "shadow-[0px_16px_40px_0px_rgba(26,29,35,0.16)] [contain:paint]",
    isClosing ? "pointer-events-none" : "pointer-events-auto"
  )

export const headerRow = cn("flex items-start justify-between")

export const closeButton = cn(
  "flex h-9 w-9 items-center justify-center rounded-full bg-white/[.24] transition-colors hover:bg-white/[.32]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
)

export const titleWrapper = cn("flex flex-col gap-1")

export const title = cn(
  "font-buenosAires text-lg font-bold leading-6 tracking-[-0.36px] text-white"
)

export const description = cn("text-sm leading-5 tracking-[-0.28px] text-white/[.72]")

export const form = cn("flex flex-col gap-6")

export const emailField = cn("flex flex-col gap-2")

export const emailInput = (hasError: boolean) =>
  cn(
    "h-12 w-full rounded-xl border bg-white/[.24] px-4 text-base tracking-[-0.32px] text-white",
    "outline-none transition-colors placeholder:text-white",
    "focus:border-white",
    hasError ? "border-red-300" : "border-white/[.32]"
  )

export const emailError = cn("text-xs font-bold leading-4 text-white")

export const consent = cn("flex cursor-pointer items-center gap-3")

export const checkboxBox = (isChecked: boolean) =>
  cn(
    "flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 transition-colors",
    "peer-focus-visible:ring-2 peer-focus-visible:ring-white peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-blurple-500",
    isChecked ? "border-white bg-white" : "border-white/[.32] bg-white/[.32]"
  )

export const consentText = cn(
  "font-buenosAires text-xs font-semibold leading-4 tracking-[-0.24px] text-white"
)

export const submitButton = cn(
  "flex h-12 w-full items-center justify-center rounded-full bg-white/[.24] transition-colors hover:bg-white/[.32]",
  "font-buenosAires text-sm font-bold leading-5 tracking-[-0.28px] text-white",
  "disabled:pointer-events-none disabled:text-white/[.48]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
)
